export const getUser = user => ({
  type: "GET_USER",
  user
});

export const loading = state => ({
  type: "LOADING",
  loading: state
});

export const getVacancies = vacancies => ({
  type: "GET_VACANCIES",
  vacancies
});

export const showNotification = state => ({
  type: "SHOW_NOTIFICATION",
  state
});

export const selectedApplicants = applicants => ({
  type: "SELECTED_APPLICANTS",
  applicants
});



// WEBPACK FOOTER //
// ./src/actions.js